<template>
    <div class="calendar-height">
        <FullCalendar ref="fullCalendar" :options="calendarOptions"  />
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment';

export default {
    props: {
        calendarEvents: Array
    },
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    mounted(){
        this.obj = this.$refs.fullCalendar.getApi();      

    },
    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin,timeGridPlugin],
                initialView: 'dayGridMonth',
                selectable: true,
                eventColor: "#007bff",
                eventTextColor: "#fff",
                dateClick: this.renderDate,
                events: this.calendarEvents,
                eventClick: this.eventSelected,
                eventMouseEnter: this.renderEventHover,
                selectAllow: this.selectRules,
                dayMaxEvents: true,
                displayEventEnd:true,
                // aspectRatio: 2.5,
                height: '100%',
                headerToolbar: {
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                eventTimeFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    meridiem: 'short'
                },
                buttonText: {
                    today:'Today',
                    day: 'Day',
                    week: 'Week',
                    month: 'Month'
                }
            }
        }
    },
    methods: {
        eventSelected(event, jsEvent, view) {
            // $(event.el).addClass('clickThrough');
            this.$emit('event-selected', event.event)
        },
        forceRerender() {
            this.obj.render();
        },
        renderDate(date, element) {
            this.$emit('date-click', date)
        },
        selectRules(selectInfo) {
            return (selectInfo.start < new Date(this.$options.filters.formatDate(new Date()))) ? false : true;
        },
        renderEventHover(info) {
            let fullCalendar = this.$refs.fullCalendar.getApi().currentData.renderableEventStore.instances;
            console.log('full cal ref',fullCalendar);
            this.$emit('mouse-hover-event', info)
        },
        // eventRender: function(info) {
        //     var tooltip = new Tooltip(info.el, {
        //       title: info.event.extendedProps.description,
        //       placement: 'top',
        //       trigger: 'hover',
        //       container: 'body'
        //     });
        // },


    }
}
</script>
<style>
    .clickThrough {
    pointer-events: none;
}
</style>
